import { TrackJS } from 'trackjs';
import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import PlanSelector from '@component/form/element/planselector';

export const getYearlyDiscountRate = (subscriptionPricing) => {
  const month = subscriptionPricing.month.total_cents;
  const monthTotal = month * 12;
  const yearTotal = subscriptionPricing.year.total_cents;

  if (!monthTotal || !yearTotal) {
    return 17; // Fallback to default 17% yearly discount
  }

  // Yearly pricing should not equal or be higher than pricing for 12 recurring months
  if (yearTotal >= monthTotal) {
    TrackJS.track({
      name: 'InvalidYearlyDiscount',
      message: `yearly pricing (${yearTotal}) equals or is higher than pricing for 12 recurring months (${month})`,
      stack: 'init/pricing',
    });
    return 17; // Fallback to default 17% yearly discount
  }

  return Math.round(((monthTotal - yearTotal) / monthTotal) * 100);
};

const Plans = ({
  subscriptionPricing,
  billing,
  userHasValidCoupon,
  onPlanChange,
}) => {
  const currencyCode = subscriptionPricing.month.currency.toUpperCase();
  const currencySign = I18n.t(`number.currency.${currencyCode}`);

  return (
    <React.Fragment>
      <PlanSelector
        key="planSelector_yearly"
        label={I18n.t('page.payment_methods.plan_details.year')}
        price={subscriptionPricing.year.total}
        copy={I18n.t('form.plan.year.discount', {
          rate: getYearlyDiscountRate(subscriptionPricing),
        })}
        defaultValue="yearly"
        name="yearlyBilling"
        onChange={onPlanChange}
        checked={billing === 'yearly'}
        currencyCode={currencyCode}
        currencySign={currencySign}
      />
      <PlanSelector
        key="planSelector_monthly"
        label={I18n.t('page.payment_methods.plan_details.month')}
        price={subscriptionPricing.month.total}
        copy={I18n.t('form.plan.month.sub-label')}
        defaultValue="monthly"
        name="monthlyBilling"
        onChange={onPlanChange}
        disabled={userHasValidCoupon}
        checked={billing === 'monthly'}
        currencyCode={currencyCode}
        currencySign={currencySign}
      />
    </React.Fragment>
  );
};

Plans.propTypes = {
  subscriptionPricing: PropTypes.object.isRequired,
  billing: PropTypes.string.isRequired,
  userHasValidCoupon: PropTypes.bool.isRequired,
  onPlanChange: PropTypes.func.isRequired,
};

export default Plans;
